<template>
    <div class="radio mb-2">
        <div class="border rounded-md border-gray-300 block p-4">
            <label class="block text-sm font-medium leading-5 text-gray-700">
                <div class="flex justify-between">
                    <slot>HEADER</slot>
                    <toggle v-model="toggle"></toggle>
                </div>
            </label>
            <p class="mt-2 text-sm text-gray-500" v-if="hasHelperSlot">
                <slot name="helper"></slot>
            </p>
            <div class="mt-2">
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Toggle from "./Toggle";

export default {
    name: "ToggleGroup",
    components: {Toggle},
    props: ['value'],

    computed: {
        hasHelperSlot() {
            return !!this.$slots['helper'];
        },
        toggle: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style scoped>

</style>
